/* eslint-disable import/prefer-default-export */
export const initialState = {
  idToken: false,
  error: false,
  accessToken: false,
  profile: false,
  loading: false,
  userinfo: false,
  clientSelect: false,
  subSelect: false,
  subMeta: false,
  tab: 'home',
};
